import PropTypes from 'prop-types';
import classNames from 'classnames';
import InfoCard from './InfoCard';

function InfoCards({
  className = '',
  style = {},
  data = {},
  currentView = 'impression',
}) {
  const isViewOnly = data.partnerAccessLevel === 'view-all'
    || data.partnerAccessLevel === 'view-limited'
    || data.partnerAccessLevel === 'none';
  const isHidden = data.partnerAccessLevel === 'none';

  // is the current view impression or spot based?
  const isImpression = currentView === 'impression';
  const deliveredImpressions = data.deliveredImpressions || 0;
  const targetImpressions = data.targetImpressions || 0;
  const totalImpressions = data.totalImpressions || 0;
  const deliveredSpots = data.deliveredSpots || 0;
  const totalSpots = data.totalSpots || 0;
  const mediaCost = data.mediaCost || 0;
  const mediaCostSpotBasis = data.mediaCostSpotBasis || 0;
  // use spot based media cost when the current view is spot based
  const useMediaCost = isImpression
    ? mediaCost
    : mediaCostSpotBasis;
  const budget = data.budget || 0;
  const cpm = data.cpm || data.weightedCpm || 0;
  const mediaValuePercent = isViewOnly
    ? 'Unavailable'
    : (useMediaCost / budget) * 100 || 0;

  return (
    <div
      className={classNames('InfoCards', className)}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: 16,
        margin: '2rem',
        ...style,
      }}
    >
      {isImpression && (
        <InfoCard
          valueLabel="Impressions Delivered"
          valueLabelBadge={data.segmentType === 'added-value'
            ? 'Added Value'
            : ''}
          value={deliveredImpressions}
          subValues={data.orderType !== 'always-on-pmp'
            ? [{
              label: 'Target Budgeted Impressions',
              value: targetImpressions,
            }, {
              label: 'Total Allocated Impressions',
              value: totalImpressions,
            }]
            : []}
          percentage={data.orderType !== 'always-on-pmp'
            ? (deliveredImpressions / targetImpressions) * 100 || 0
            : null}
          isViewOnly={isViewOnly}
        />
      )}

      <InfoCard
        valueLabel="Spots Delivered"
        value={deliveredSpots}
        subValues={data.orderType !== 'always-on-pmp'
          ? [{
            label: 'Total Spots',
            value: totalSpots,
          }]
          : []}
        percentage={data.orderType !== 'always-on-pmp'
          ? (deliveredSpots / totalSpots) * 100 || 0
          : null}
        isViewOnly={isViewOnly}
      />

      {!isViewOnly && (
        <>
          <InfoCard
            valueLabel={`${isImpression ? 'Impression' : 'Spot'} Media Value Delivered`}
            value={useMediaCost}
            valueBadge={mediaValuePercent >= 1
              // only show the badge when percent complete reaches at least 1%
              ? `${Math.floor(mediaValuePercent)}%`
              : ''}
            subValues={!isHidden && data.orderType !== 'always-on-pmp'
              ? [{
                label: 'Target Budget',
                value: budget,
              }]
              : []}
            percentage={!isHidden && data.orderType !== 'always-on-pmp'
              ? mediaValuePercent
              : null}
            type="currency"
            currencyCode={data.currencyCode}
            currencyOptions={{
              maximumFractionDigits: 2,
            }}
            isViewOnly={isViewOnly}
          />

          {isImpression && (
            <InfoCard
              valueLabel="Weighted CPM (ECPM)"
              value={cpm}
              align={data.orderType !== 'always-on-pmp'
                ? 'center'
                : 'top'}
              type="currency"
              currencyCode={data.currencyCode}
              isViewOnly={isViewOnly}
            />
          )}
        </>
      )}
    </div>
  );
}

InfoCards.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  data: PropTypes.object,
  currentView: PropTypes.string,
};

export default InfoCards;
